<template>
  <section class='error404'>
    <img class="ot2_animation" src="../assets/img/ot2-animation.gif"></img>
    <div class="text">
           <h2>Protocol not found</h2>
      <span>
        Are you looking for a version 1 Python Protocol API protocol? All public APIv1 protocols are still available
        <a target="_blank" rel="noopener noreferrer" href="https://protocol-delivery.protocols.opentrons.com">here</a>.
      </span>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Error404Page'
  }
</script>

<style scoped>
  .error404{
    padding-top: 3em;
    color: #7b7b7b;
  }
  .ot2_animation{
    float: left;
    padding-right: 2em;
  }
</style>



// WEBPACK FOOTER //
// Error404Page.vue?f55ab820